export const CalendarEventTypes = Object.freeze({
    ActionDueDate: 0,
    PatientEvent: 1,
    CustomEvent: 2,
  });